import { useState } from 'react'
import { useNavigate } from 'react-router-dom'

interface HeaderProps {
  variant?: 'default' | 'dashboard'
  userName?: string
}

function Header({ variant = 'default', userName }: HeaderProps) {
  const navigate = useNavigate()
  const [isDropdownOpen, setIsDropdownOpen] = useState(false)

  const handleLogout = async () => {
    try {
      await fetch('/api/auth/logout', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
      })
    } catch (error) {
      console.error('Logout failed:', error)
    } finally {
      // Always navigate back to home, even if the backend call fails
      navigate('/')
    }
  }

  return (
    <header className="border-b border-gray-200 bg-white/95 backdrop-blur-sm sticky top-0 z-50">
      <div className={`${variant === 'dashboard' ? 'w-full px-8' : 'max-w-7xl mx-auto px-6'} py-4 flex items-center justify-between`}>
        {/* Acme Corp Logo */}
        <button
          onClick={() => navigate('/')}
          className="flex items-center gap-3 hover:opacity-80 transition-opacity"
        >
          <div className="w-10 h-10 bg-acme-primary rounded-lg flex items-center justify-center">
            <span className="text-gray-900 font-black text-xl">A</span>
          </div>
          <h1 className="text-2xl font-bold text-gray-900">
            {variant === 'dashboard' ? 'ACME Portal' : 'ACME Corp'}
          </h1>
        </button>

        {/* Right Side */}
        <div className="flex items-center gap-4">
          {variant === 'dashboard' && userName ? (
            <div className="relative">
              <button
                onClick={() => setIsDropdownOpen(!isDropdownOpen)}
                className="flex items-center gap-3 hover:bg-gray-50 p-2 rounded-xl transition-colors"
              >
                <div className="text-right hidden sm:block">
                  <p className="text-sm font-bold text-gray-900">Welcome, {userName}</p>
                  <p className="text-xs text-gray-500">Authenticated via YubiKey&reg;</p>
                </div>
                <div className="w-10 h-10 bg-yubico-green-400 rounded-full flex items-center justify-center shadow-sm">
                  <span className="text-white font-bold text-lg">{userName.charAt(0)}</span>
                </div>
                <i className="iconoir-nav-arrow-down text-gray-400 text-xl"></i>
              </button>

              {/* Dropdown Menu */}
              {isDropdownOpen && (
                <div className="absolute right-0 top-full mt-2 w-48 bg-white rounded-xl shadow-xl border border-gray-100 py-1 overflow-hidden animate-in fade-in zoom-in-95 duration-200 z-50">
                  <div className="px-4 py-3 border-b border-gray-50 sm:hidden">
                    <p className="text-sm font-bold text-gray-900">{userName}</p>
                    <p className="text-xs text-gray-500">Authenticated</p>
                  </div>
                  <button
                    onClick={handleLogout}
                    className="w-full text-left px-4 py-3 text-sm text-gray-700 hover:bg-red-50 hover:text-red-600 flex items-center gap-2 transition-colors"
                  >
                    <i className="iconoir-log-out text-xl"></i>
                    Sign out
                  </button>
                </div>
              )}
            </div>
          ) : (
            <>
              <div className="flex items-center gap-2">
                <div className="w-8 h-8 bg-yubico-green-400 rounded-full flex items-center justify-center">
                  <span className="text-white font-black text-sm">Y</span>
                </div>
                <span className="font-bold text-gray-900">
                  Yubico<sup className="text-xs">&reg;</sup>
                </span>
              </div>
            </>
          )}
        </div>
      </div>
    </header>
  )
}

export default Header
